<template>
  <div class="zones"></div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { generateColors } from '@/utils/colors.util'

export default {
  name: 'Zones',
  props: {
    map: {
      type: Object,
      required: true,
    },
    zones: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
  },
  watch: {
    zones: {
      deep: true,
      handler() {
        this.resetGeoJson()
        this.setCurrentZone(null)
        this.addGeoJson()
      },
    },
  },
  beforeMount() {
    if (!this.computedSettings.with_zone) {
      this.$router.push({ name: 'markers', params: this.$route.params, query: this.$route.query })
    }
  },
  mounted() {
    this.addGeoJson()
  },
  computed: {
    ...mapState({
      geoJsons: state => state.data.geoJsons,
      brandSettings: state => state.data.settings,

      currentKpi: state => state.refine.currentKpi,
    }),
    computedSettings() {
      return this.brandSettings.filter(setting => setting.key === this.currentKpi)[0]
    },
  },
  methods: {
    ...mapActions({
      getClientGeoJsons: 'data/getClientGeoJsons',
      setCurrentZone: 'data/setCurrentZone',

      toggleRefreshZones: 'radar/toggleRefreshZones',
    }),
    async getJsons() {
      this.toggleRefreshZones(true)
      await this.getClientGeoJsons(this.zones).then(() => {
        this.toggleRefreshZones(false)
        return true
      })
    },
    async addGeoJson() {
      await this.getJsons()

      this.geoJsons.forEach(geojson => {
        try {
          this.map.data.addGeoJson(geojson)
        } catch (e) {
          console.error(`The following geosjon is invalid: ${geojson.features[0].properties.name}\n${e}`)
        }
      })
      this.setGeoJsonColors()
      this.setEventListener()
    },
    setGeoJsonColors() {
      this.map.data.setStyle(feature => {
        try {
          const key = feature.getProperty('value')
          const zone = this.zones.filter(zone => zone.key === key)[0]
          return {
            fillColor: generateColors(zone.value, this.filters) || 'transparent',
            strokeWeight: 0.5,
            fillOpacity: 0.8,
          }
        } catch (e) {
          return {
            fillColor: 'transparent',
            strokeWeight: 0,
            fillOpacity: 0,
          }
        }
      })
    },
    resetGeoJson() {
      this.map.data.forEach(feature => {
        this.map.data.remove(feature)
      })
    },
    setEventListener() {
      this.map.data.addListener('click', e => {
        const key = e.feature.getProperty('value')
        const zone = this.zones.filter(zone => zone.key === key)[0]
        this.setCurrentZone(zone)
      })
    },
  },
  beforeDestroy() {
    this.setCurrentZone(null)
    this.resetGeoJson()
  },
}
</script>
